// extracted by mini-css-extract-plugin
module.exports = {"input":"Price-module__input___rzPM3","warningText":"Price-module__warningText___2Wro7"};